import React, { useEffect, useState } from "react";
import Menu from "./Menu/Menu";
import useSize from "../../../../Utils/useSize/useSize";
import Backend from "../../../../Backend/Backend";
import toast from "react-hot-toast";
import Loading from "../../../../Utils/Loading/Loading";
import useSound from "use-sound";
import Error from "../../../../Sound/Error.wav";
import NotFound from "../../../../Utils/NotFound/NotFound";
import LoginHistoryCard from "./LoginHistoryCard";
import moment from "moment";
import Filter from "./Filter/Filter";

const backend = await new Backend().init();

export default function LoginHistory() {
  const [play] = useSound(Error);
  const windowSize = useSize();

  const [history, setHistory] = useState([]); // FIXED HERE
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    loadLoginHistory();
  }, []);

  const loadLoginHistory = (a, b) => {
    setLoading(true);

    const data = {
      server: localStorage.getItem("server"),
      id: localStorage.getItem("id"),
      username: localStorage.getItem("username"),
      token: localStorage.getItem("token"),
      start: a ?? moment().startOf("week"),
      end: b ?? moment().endOf("week"),
    };

    backend.loginhistory(data).then((r) => {
      setLoading(false);
      if (r.error === "False") {
        setHistory(r.history);
      } else {
        play();
        toast.error(r.message);
      }
    });
  };

  return (
    <div>
      <Filter
        records={history.length}
        loadLoginHistory={loadLoginHistory}
        history={history}
      />

      <Menu />

      <div
        key={history}
        className="flex flex-col"
        style={{ height: windowSize[1] - 190 }}
      >
        {loading ? (
          <div className="loadingContainer">
            <Loading height={windowSize[1] - 190} />
          </div>
        ) : history.length > 0 ? (
          <div
            className="overflow-y-scroll w-full"
            style={{ height: windowSize[1] - 190 }}
          >
            {history.map((item) => (
              <LoginHistoryCard key={item.id} item={item} />
            ))}
          </div>
        ) : (
          <NotFound
            height={windowSize[1] - 190}
            title="Nothing here"
            subtext="No Login Logs Found."
          />
        )}
      </div>
    </div>
  );
}
